<template>
  <v-card>
    <v-form @submit.prevent="true" v-model="valid" autocomplete="off">
      <v-container class="pt-3 pb-0">
        <h3>Clone Fields and Responses</h3>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedField"
              :items="allMappedQA"
              item-title="fullLabel"
              item-value="clientId"
              label="Field"
              hide-no-data
              hint="Please search for the field that you want to clone"
              return-object
              hide-selected
              :rules="responseRule"
              persistent-hint
              clearable
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-checkbox color="green" label="Include cascade" v-model="includeChildren" hide-details></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="answerTarget"
              :items="answers"
              item-title="fullLabel"
              item-value="clientId"
              label="Target response"
              hide-no-data
              hint="Please search for the response that you want to add the selected field"
              return-object
              hide-selected
              :rules="responseRule"
              persistent-hint
              clearable
              required
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="!valid" @click="clone">Clone</v-btn>
        <v-btn @click="close">Close</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'CloneQA',
  props: {
    allQA: Array
  },
  data() {
    return {
      selectedField: null,
      answerTarget: null,
      includeChildren: false,
      valid: false
    }
  },
  computed: {
    allMappedQA() {
      return this.allQA.map(({ parentQuestion }) => {
        return { ...parentQuestion }
      })
    },
    answers() {
      return this.allQA
    },
    responseRule() {
      return [v => (!v || !(v || {}).clientId ? 'Required' : true)]
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    clone() {
      this.$emit('clone', this.selectedField, this.answerTarget, this.includeChildren)
    }
  }
}
</script>
